<template lang="pug">
  .form-item.group__select
    span.form-item__title(v-if="title")
      | {{title}}
    .form-item__block(v-click-outside="close")
      span.form-item__error(v-if="error")
        | {{error}}

      .form-item__select.select(@click="toggleOpen")
        input.form-item__input(
          :value="selected ? 'Курс: '+selected : ''"
          :disabled="true"
          :placeholder="placeholder"
        )
      SlideUpDown.select__slider.-width-170p-(
        :duration="slideDuration"
        :active="isOpen"
      )
        .select__field
          Input(
            placeholder="Поиск курса"
            v-model="searchText"
            style="margin-bottom: 5px;"
          )
          .group__select-list( v-for="(field, idx) in computedFields" :key="'field'+idx" )
            span.group__select-list-folder
              | {{field.folderName}}
            .group__select-list(v-for="fieldItem in field.courses" :key="fieldItem.id+'fieldItem'")
              .group__select-list-tasks
                span.group__select-list-text(
                    @click="click(fieldItem)"
                  )
                  | {{fieldItem.name}}

      Icon.select__icon.form-item__icon(
        :icon="!icon ? 'arrow-down' : icon"
        @click="toggleOpen"
        :class="{'-opened-': isOpen}"
      )

</template>

<script>
import _ from 'lodash';
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';

export default {
  components: {
    SlideUpDown
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    title: {},
    error: {},
    placeholder: {},
    icon: {},
    value: {}
  },
  data() {
    return {
      searchText: '',
      isOpen: false,
      slideDuration: 200,
      selectData: {},
      selected: ''
    };
  },
  computed: {
    computedFields() {
      const fields = [];
      _.cloneDeep(this.fields).forEach(el => {
        if (this.searchText) {
          el.courses = el.courses.filter(elem =>
            elem.name.toLowerCase().includes(this.searchText.toLowerCase())
          );
        }

        el.courses.length && fields.push(el);
      });
      return fields;
    }
  },
  watch: {
    value() {
      this.setData();
    },
    fields() {
      this.setData();
    }
  },
  mounted() {
    if (this.fields && this.value) {
      this.setData();
    }
  },
  methods: {
    setData() {
      _.cloneDeep(this.fields).forEach(el => {
        const data = el.courses.find(elem => elem.id == this.value);
        if (data && data.name) {
          this.selected = data.name;
        }
      });
    },
    toggleOpen() {
      this.fields.length > 0 && (this.isOpen = !this.isOpen);
    },
    close() {
      this.isOpen = false;
      this.searchText = '';
    },
    click(value) {
      // this.selected = value ? value.name : ''
      this.$emit('input', value ? value.id : '');
      this.close();
    }
  }
};
</script>
